import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { useTheme } from 'styled-components';

import { CheckIcon, CloseIcon } from 'app/commonComponents/icons';
import { PASSWORD_MINIMUM_LENGTH } from '../constants';

function PasswordCheck({ fieldName }) {
  const {
    values: { [fieldName]: value },
    errors: { [fieldName]: errors },
  } = useFormikContext();
  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <ValidationCheck
        requirement={i18n.sprintf(
          i18n.gettext('Min. %s characters'),
          PASSWORD_MINIMUM_LENGTH
        )}
        isPassing={
          value ? (errors ? errors.hasMinimumLength : true) : undefined
        }
      />
      <ValidationCheck
        requirement={i18n.gettext('Min. 1 lower- and upper-case letter')}
        isPassing={
          value
            ? errors
              ? errors.containsLowercaseLetter && errors.containsUppercaseLetter
              : true
            : undefined
        }
      />
      <ValidationCheck
        requirement={i18n.gettext('Min. 1 digit')}
        isPassing={value ? (errors ? errors.containsDigit : true) : undefined}
      />
      <ValidationCheck
        requirement={i18n.gettext('Min. 1 special character')}
        isPassing={
          value ? (errors ? errors.containsSpecialCharacter : true) : undefined
        }
      />
    </div>
  );
}

PasswordCheck.propTypes = {
  fieldName: PropTypes.string.isRequired,
};

export default PasswordCheck;

function ValidationCheck({ requirement, isPassing }) {
  const theme = useTheme();
  return (
    <div
      style={{
        alignItems: 'center',
        color: isPassing
          ? theme.colors.java
          : isPassing === false
            ? theme.colors.amaranth
            : theme.colors.dustyGray,
        display: 'flex',
        gap: '0.75rem',
        marginBottom: '0.5rem',
      }}
    >
      {isPassing ? (
        <CheckIcon xsmall />
      ) : (
        <CloseIcon
          xsmall
          style={{ visibility: isPassing === false ? 'visible' : 'hidden' }}
        />
      )}
      {requirement}
    </div>
  );
}

ValidationCheck.propTypes = {
  requirement: PropTypes.string.isRequired,
  isPassing: PropTypes.bool,
};
